// extracted by mini-css-extract-plugin
export default {"home":"home_home__b9HcV","blur":"home_blur__hQbTc","mainContainer":"home_mainContainer__-mp2x"};